import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputSwitchModule } from 'primeng/inputswitch';
import { NrToggleSwitchComponent } from 'src/app/shared/components/nr-toggle-switch/nr-toggle-switch.component';
import { AlertCategory, AlertPreference } from '../../Interfaces/profile';

@Component({
  selector: 'alerts-subscription',
  templateUrl: './alerts-subscription.component.html',
  styleUrl: './alerts-subscription.component.scss',
  imports: [
    InputSwitchModule,
    NrToggleSwitchComponent,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
  ],
})
export class AlertsSubscriptionComponent implements OnInit {
  @Input() alerts!: AlertCategory[];
  @Input() alertsFormGroup!: FormArray;
  @Output() alertPreference = new EventEmitter<AlertPreference[]>();
  fb = inject(FormBuilder);

  ngOnInit() {
    this.alertsFormGroup = this.fb.array([]);
    this.createAlertForm();
  }

  createAlertForm(): void {
    this.alerts.forEach((category) => {
      const preferencesArray = this.fb.array(
        category.preferences.map(({ alertDescription, isActive }) =>
          this.fb.group({
            alertDescription: [alertDescription],
            isActive: [isActive],
          }),
        ),
      );

      const categoryGroup = this.fb.group({
        alertCategory: [category.alertCategory],
        preferences: preferencesArray,
      });

      this.alertsFormGroup.push(categoryGroup);
    });
  }

  getIsActiveControl(catIdx: number, prefIdx: number): FormControl {
    const categoryGroup = this.alertsFormGroup.at(catIdx) as FormGroup;
    const preferencesArray = categoryGroup.get('preferences') as FormArray;
    const preferenceGroup = preferencesArray.at(prefIdx) as FormGroup;
    return preferenceGroup.get('isActive') as FormControl;
  }

  onAlertSubscriptionChange(): void {
    this.alertPreference.emit(this.alertsFormGroup.value);
  }
}
